module.exports = __webpack_public_path__ + "static/media/rockWall.6968aeab.png";